import { render } from "./Frontpage.vue?vue&type=template&id=eb529f66&scoped=true"
import script from "./Frontpage.vue?vue&type=script&lang=js"
export * from "./Frontpage.vue?vue&type=script&lang=js"

import "./Frontpage.vue?vue&type=style&index=0&id=eb529f66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb529f66"

export default script